import { Lock, MailCheck, MailOpen } from 'lucide-react';
import type { ConversationDetail } from '@/shared/api';
import { Button } from '@/shared/components';

/** Aktionen im Kopf einer Unterhaltung; jede erscheint nur, wo sie hier möglich ist. */
export function ConversationActions({
  thread,
  onClose,
  onNoReplyNeeded,
  onMarkRead,
}: {
  thread: ConversationDetail;
  onClose?: () => void;
  onNoReplyNeeded?: () => void;
  /** Nur im Support-Modus gesetzt: dort markiert das Ansehen allein nichts als gelesen. */
  onMarkRead?: () => void;
}) {
  return (
    <div className="flex basis-full flex-wrap items-center gap-2 sm:basis-auto">
      {onMarkRead && (
        <Button
          type="button"
          variant="secondary"
          className="rounded-pill min-h-11"
          leftIcon={<MailOpen size={14} aria-hidden />}
          onClick={onMarkRead}
        >
          Als gelesen markieren
        </Button>
      )}
      {onNoReplyNeeded && thread.channel === 'BookingCom' && !thread.isClosed && (
        <Button
          type="button"
          variant="secondary"
          className="rounded-pill min-h-11"
          leftIcon={<MailCheck size={14} aria-hidden />}
          onClick={onNoReplyNeeded}
        >
          Keine Antwort nötig
        </Button>
      )}
      {onClose && !thread.isClosed && (
        <Button
          type="button"
          variant="ghost"
          className="rounded-pill border-ink min-h-11 border"
          leftIcon={<Lock size={14} aria-hidden />}
          onClick={onClose}
        >
          Schließen
        </Button>
      )}
    </div>
  );
}
